export const USER_REGISTER = 'AOR/USER_REGISTER';
export const USER_FORGOTPASS = 'AOR/USER_FORGOTPASS';

export const userRegister = (payload, pathName) => ({
	type: USER_REGISTER,
	payload: payload,
	meta: { authAddon: true, pathName: pathName }
});

export const userForgotpass = (payload, pathName) => ({
	type: USER_FORGOTPASS,
	payload: payload,
	meta: { authAddon: true, pathName: pathName }
});



// WEBPACK FOOTER //
// ./src/AuthActionAddons.js